
import React from "react"
import moment from 'moment'
import { Table, Divider, Space, Button, Pagination, Modal, message } from "antd"

import { AdminService } from "@/services"
import CommonLayout from "@/common/Layout"

import CollectionSiteAddModal from "./addModal"
import CollectionSiteEditModal from "./editModal"

class CollectionSitePage extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            collectionSites: [],
            pagination: {
                count: 0,
                pageSize: 20,
                page: 1
            },
            addModalOpen: false,
            editingRecord: null
        }
    }

    componentDidMount() {
        const page = 1
        this.reloadPaginateCollectionSites(page)
    }

    reloadPaginateCollectionSites(page) {

        const { pagination } = this.state

        const params = {
            page: page,
            page_size: pagination.pageSize
        }

        AdminService.get_collection_site_list(params).then((response) => {
            const { status, body } = response.data
            if (status <= 0) {
                console.error("get_collection_site_list api return status", status)
                return
            }

            this.setState({
                collectionSites: body.sites,
                pagination: {
                    page: body.page,
                    pageSize: body.pageSize,
                    count: body.count
                }
            })
        })
    }

    openAddModal() {
        this.setState({ addModalOpen: true })
    }

    closeAddModal() {
        this.setState({ addModalOpen: false })
    }

    submitAddModal(formData) {

        const params = {
            site_id: formData.siteId,
            name: formData.name
        }

        const messageKey = "notice"

        message.loading({ content: "正在保存...", key: messageKey })

        AdminService.create_collection_site(params).then((response) => {

            const { status, body } = response.data

            if (status <= 0) {
                message.error(body)
                return
            }

            this.reloadPaginateCollectionSites(1)

            this.closeAddModal()

            message.success({ content: "添加成功", key: messageKey })

        }).catch((error) => {
            message.error({ content: "添加失败", key: messageKey })
            console.error(error)
        })
    }

    openEditModal(record) {
        this.setState({ editingRecord: record })
    }

    closeEditModal() {
        this.setState({ editingRecord: null })
    }

    submitEditModal(formData) {

        const params = {
            collection_site_id: formData.collectionSiteId,
            name: formData.name,
            site_id: formData.siteId
        }

        const messageKey = "notice"

        message.loading({ content: "正在保存...", key: messageKey })

        AdminService.update_collection_site(params).then((response) => {

            const { status, body } = response.data

            if (status <= 0) {
                message.error(body)
                return
            }

            const { page } = this.state.pagination
            this.reloadPaginateCollectionSites(page)

            this.closeEditModal()

            message.success({ content: "保存成功", key: messageKey })

        }).catch((error) => {
            message.error({ content: "保存失败", key: messageKey })
            console.error(error)
        })

    }

    deleteSite(record) {

        const params = {
            collection_site_id: record.id
        }

        const messageKey = "notice"

        message.loading({ content: "正在删除...", key: messageKey })

        return AdminService.delete_collection_site(params).then((response) => {

            const { status, body } = response.data

            if (status <= 0) {
                message.error(body)
                return
            }

            const { page } = this.state.pagination
            this.reloadPaginateCollectionSites(page)

            message.success({ content: "删除成功", key: messageKey })

        }).catch((error) => {
            message.error({ content: "删除失败", key: messageKey })
            console.error(error)
        })
    }

    confirmAndDeleteSite(record) {
        Modal.confirm({
            title: `确认要删除模板"${record.name}"吗？`,
            content: '删除后将不可恢复，请谨慎操作',
            okText: "确认",
            cancelText: "取消",
            onOk: async () => {
                await this.deleteSite(record)
            }
        })
    }

    previewSite(record) {
        const collectionId = record.id
        if (!collectionId) return

        window.open(`/collection/${collectionId}`, "_blank")
    }

    renderSitesTable() {

        const { collectionSites } = this.state

        const columns = [
            {
                title: "模板ID",
                dataIndex: "id",
                key: "id",
                align: "center"
            },
            {
                title: '模板名称',
                dataIndex: 'name',
                key: 'name',
                align: "center"
            },
            {
                title: '添加时间',
                dataIndex: 'createTime',
                key: 'createTime',
                align: "center",
                render: (createTime, record) => {
                    if (!createTime) return null
                    return moment(createTime).format('YYYY-MM-DD HH:mm')
                }
            },
            {
                title: '操作',
                key: 'action',
                align: "center",
                render: (text, record) => (
                    <Space>
                        <a onClick={() => this.previewSite(record)}>预览</a>

                        <Divider type="vertical" />
                        <a onClick={() => this.openEditModal(record)}>编辑</a>
                        <Divider type="vertical" />
                        <a onClick={() => this.confirmAndDeleteSite(record)}>删除</a>
                    </Space>
                )
            },
        ];

        return (
            <Table
                dataSource={collectionSites}
                columns={columns}
                rowKey="id"
                pagination={false}
            />
        )
    }

    renderAddModal() {

        const { addModalOpen } = this.state
        if (!addModalOpen) return null

        return (
            <CollectionSiteAddModal
                onCancel={() => this.closeAddModal()}
                onSubmit={(formData) => this.submitAddModal(formData)}
            />
        )
    }

    renderEditModal() {

        const { editingRecord } = this.state
        if (!editingRecord) return null

        const formData = {
            collectionSiteId: editingRecord.id,
            name: editingRecord.name
        }

        return (
            <CollectionSiteEditModal
                formData={formData}
                onCancel={() => this.closeEditModal()}
                onSubmit={(formData) => this.submitEditModal(formData)}
            />
        )
    }

    renderPagination() {

        const { page, pageSize, count } = this.state.pagination

        return (
            <Pagination
                current={page}
                pageSize={pageSize}
                total={count}
                hideOnSinglePage={true}
                onChange={(page) => this.reloadPaginateCollectionSites(page)}
            />
        )
    }

    renderPageContent() {
        return (
            <React.Fragment>
                <h2>模板库</h2>

                <div style={{ marginBottom: 20 }}>
                    <Button type="primary" onClick={() => this.openAddModal()}>添加模板</Button>
                </div>
                <div style={{ marginBottom: 20 }}>
                    {this.renderSitesTable()}
                </div>

                {this.renderPagination()}
                {this.renderAddModal()}
                {this.renderEditModal()}
            </React.Fragment>
        )
    }

    render() {
        return (
            <CommonLayout selectedMenuKey="collectionSites" openMenuKeys={["groupSite"]}>
                {this.renderPageContent()}
            </CommonLayout>
        )
    }

}

export default CollectionSitePage